export default __webpack_public_path__ + "static/laminas_7-05143024d3d36869fd33a0aef326481c.png";